import { ChevronRightIcon } from "@heroicons/react/outline";
import { Workflow, Page } from "./interface";
import { useTranslation } from "react-i18next";

interface Props {
  workflow?: Workflow;
  currentPage: Page;
}

function Breadcrumbs(props: Props) {
  const { t } = useTranslation();
  const { workflow, currentPage } = props;

  if (!workflow)
    return null

  return (
    <div className="flex items-center gap-2 w-full justify-center mb-8 text-xs">
      <div className={`${(currentPage === "DATA" || currentPage === "RECIPIENTS") ? "text-blue font-semibold" : "text-gray-400 font-semibold"}`}>
        {t("Configure")}
      </div>
      <ChevronRightIcon className="w-4 h-4 text-gray-400" />
      <div className={`${currentPage === "AUTOMATION" ? "text-blue font-semibold" : "text-gray-400 font-semibold"}`}>
        {t("Generate Documents")}
      </div>
      <ChevronRightIcon className="w-4 h-4 text-gray-400" />
      <div className={`${currentPage === "PREVIEW" ? "text-blue font-semibold" : "text-gray-400 font-semibold"}`}>
        {!!workflow.review ? t("Review") : t("Complete")}
      </div>
    </div>
  );
}

export default Breadcrumbs;
